import type { TOC } from '@ember/component/template-only'
import { or } from 'ember-truth-helpers'
import sticky from 'teacher-ui-client/modifiers/sticky'

interface Signature {
  Element: HTMLTableCellElement
  Args: {
    z?: number
  }
  Blocks: {
    default: []
  }
}

export const StickyColumnTable: TOC<Signature> = <template>
  <td class="bg-inherit" ...attributes {{sticky column=true z=(or @z "4")}}>
    {{yield}}
  </td>
</template>

export default StickyColumnTable
